import { render, staticRenderFns } from "./environment-header.vue?vue&type=template&id=3b3c203e&scoped=true&"
import script from "./environment-header.vue?vue&type=script&lang=js&"
export * from "./environment-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3c203e",
  null
  
)

export default component.exports